import { useLocale } from '@tellus/locale';
import ja from './lang/ja';

export default { 'ja': ja }
/**
 * translate language
 * @param {String} key key
 * @param {import('vue-i18n').Values} values values
 * @returns {import('vue-i18n').TranslateResult}
 */
export function t(key, values) {
  return useLocale().t(key, values)
}
